module.exports = __webpack_public_path__ + "static/media/headimage4.89b2d2d7.jpg";